<template>
  <section :id="!!id.length ? id : null" :class="containerClass" class="blog-listing">
    <div id="blog-listing" class="container">
      <BackgroundShape class="blog-listing__shape" />
      <div class="blog-listing__grid">
        <FilterSelect
            :selected="selected"
            :options="filterOptions"
            :title="filtersTitle"
            :error="filtersError"
            :filter-change="filterChange"
            :default-filter-label="defaultFilterLabel"
        />
        <div v-if="items.data.length > 0" class="row">
          <div v-for="(item, index) in items.data" :key="index" class="col-12 col-sm-6 col-lg-4">
            <BlogCard v-bind="item" :view-post-text="viewPostText" />
          </div>
        </div>
        <p v-else>{{ noResultsText }}</p>
      </div>
      <LoadMore v-if="showLoadMore" :label="loadMoreText" :button-cick="loadMore" :error="loadMoreError" />
    </div>
  </section>
</template>

<script>
import { GetPosts } from '~/utils/blog';
import BlogCard from '~/components/components/BlogCard';
import FilterSelect from '~/components/elements/FilterSelect';
import LoadMore from '~/components/elements/LoadMore';
import BackgroundShape from '~/assets/images/blog/blog-listing-background.svg?inline';

export default {
  components: {
    BlogCard,
    FilterSelect,
    LoadMore,
    BackgroundShape,
  },
  props: {
    id: { type: String, default: '' },
    filtersTitle: { type: String, default: 'Filter by:', required: true },
    defaultFilterLabel: { type: String, default: 'All' },
    filters: {
      type: Array,
      default() {
        return [
          {
            title: 'City Living',
            contentCodename: 'city_living_tag',
          },
          {
            title: 'Community',
            contentCodename: 'community_tag',
          },
          {
            title: 'Innovation',
            contentCodename: 'innovation_tag',
          },
        ];
      },
    },
    viewPostText: { type: String, default: 'Explore' },
    items: {
      type: Object,
      required: true,
      default() {
        return {
          data: [
            {
              featuredImage: {
                url: 'https://www.thecollective.com/blog/wp-content/uploads/2018/12/blog-2-2000x0-c-center.jpg',
                description: '',
              },
              aggregatorImage: {
                url: 'https://www.thecollective.com/blog/wp-content/uploads/2018/12/blog-3-2000x0-c-center.jpg',
                description: '',
              },
              tag: {
                contentItem: 'city_living',
                title: 'City living',
              },
              date: '2019-01-28T00:00:00Z',
              title: 'How to make a new city feel like home',
              excerpt:
                '<p>Whether you’re moving across town or across the world, it’s tough to make a new place your home...</p>',
              author: {
                name: 'Alyssa James',
              },
              slug: 'post-slug',
            },
            {
              featuredImage: {
                url: 'https://www.thecollective.com/blog/wp-content/uploads/2018/12/blog-3-2000x0-c-center.jpg',
                description: '',
              },
              tag: {
                contentItem: 'city_living',
                title: 'City living',
              },
              date: '2019-01-28T00:00:00Z',
              title: 'A conversation between music production wizard Eric and London artist Youngr',
              excerpt: '<p>Eric Wade is a man who wears many hats. Depending on who he\'s working with...</p>',
              author: {
                name: 'Tempe Nakiska',
              },
              slug: 'post-slug',
            },
            {
              featuredImage: {
                url:
                  'https://www.thecollective.com/blog/wp-content/uploads/2018/12/superorganism-1-e1545370989566-2000x0-c-center.jpg',
                description: '',
              },
              tag: {
                contentItem: 'city_living',
                title: 'City living',
              },
              date: '2019-01-28T00:00:00Z',
              title: 'Playlist: Our songs of 2018',
              excerpt: '<p>We collectivists love a good tune, so our spaces are often filled with music...</p>',
              author: {
                name: 'Tempe Nakiska',
              },
              slug: 'post-slug',
            },
            {
              featuredImage: {
                url: 'https://www.thecollective.com/blog/wp-content/uploads/2018/12/blog-8-2000x0-c-center.jpg',
                description: '',
              },
              tag: {
                contentItem: 'city_living',
                title: 'City living',
              },
              date: '2019-01-28T00:00:00Z',
              title: 'What to do in London over Christmas 2018',
              excerpt:
                '<p>Right now is the most magical time of year in London. This city knows how to put on a show...</p>',
              author: {
                name: 'Tempe Nakiska',
              },
              slug: 'post-slug',
            },
            {
              featuredImage: {
                url: 'https://www.thecollective.com/blog/wp-content/uploads/2018/12/blog-7-2000x0-c-center.jpg',
                description: '',
              },
              tag: {
                contentItem: 'city_living',
                title: 'City living',
              },
              date: '2019-01-28T00:00:00Z',
              title: 'Six ways to make friends in London',
              excerpt:
                '<p>Moving to one of the world\'s biggest cities is always going to be a nerve wracking experience, and London...</p>',
              author: {
                name: 'Miranda Thompson',
              },
              slug: 'post-slug',
            },
            {
              featuredImage: {
                url: 'https://www.thecollective.com/blog/wp-content/uploads/2018/12/DSC01027-2000x0-c-center.jpg',
                description: '',
              },
              tag: {
                contentItem: 'city_living',
                title: 'City living',
              },
              date: '2019-01-28T00:00:00Z',
              title: 'Good times at The Collective Old Oak in 2018',
              excerpt:
                '<p>It\'s been a big year at The Collective Old Oak. We\'ve opened our doors for the world\'s biggest...</p>',
              author: {
                name: 'The Collective',
              },
              slug: 'post-slug',
            },
          ],
          pagination: {
            count: 6,
            limit: 6,
            skip: 0,
            nextPage: '',
          },
        };
      },
    },
    loadMoreText: { type: String, default: 'View More', required: true },
    noResultsText: { type: String, default: 'No posts found' },
  },
  data() {
    return {
      loading: false,
      loadMoreError: false,
      filtersError: false,
      currentPage: 1,
      postsPerPage: 6,
      postCount: 0,
      selected: '',
      filter: null,
    };
  },
  computed: {
    containerClass() {
      return {
        'blog-listing--loading': this.loading,
      };
    },
    showLoadMore() {
      return this.items.pagination.nextPage.length > 0;
    },
    filterOptions() {
      if (this.filters.length > 0) {
        const preppedFilters = this.filters.map((filter) => ({
          label: filter.title,
          value: filter.contentCodename,
        }));

        return preppedFilters;
      }

      return [];
    },
  },
  mounted() {
    this.postCount = this.items.pagination.count;
  },
  methods: {
    async filterChange(selected) {
      setTimeout(async () => {
        try {
          this.loading = true;
          this.filtersError = false;
          this.loadMoreError = false;

          if (selected.length > 0) {
            this.filter = this.prepFilter(selected);
          } else {
            this.filter = null;
          }

          const { data: newItems, pagination } = await this.getPosts(0);

          this.items.pagination = pagination;
          this.postCount = pagination.count;
          this.items.data = [...newItems];
          this.currentPage = 1;
          this.loading = false;
        } catch (error) {
          this.loading = false;
          this.filtersError = true;
          console.error(error);
        }
      }, 100);
    },
    prepFilter(selected) {
      return {
        filter: {
          key: 'tag',
          type: 'containsFilter',
          value: selected,
        },
      };
    },
    async getPosts(skip) {
      return await GetPosts(skip, this.postsPerPage, this.filter);
    },
    async loadMore() {
      if (this.items.pagination.nextPage.length > 0) {
        try {
          this.loading = true;
          this.loadMoreError = false;
          this.filtersError = false;

          const { data: newItems, pagination } = await this.getPosts(this.postCount);

          this.items.pagination = pagination;
          this.postCount = this.postCount + pagination.count;

          const newPage = this.currentPage + 1;

          if (newPage >= 1) {
            this.items.data = [...this.items.data, ...newItems];
            this.loading = false;
            this.currentPage = newPage;
          }
        } catch (error) {
          this.loading = false;
          this.loadMoreError = true;
          console.error(error);
        }
      }
    },
  },
};
</script>

<style lang="scss">
@import '~/assets/scss/atomic/components/_blog-listing.scss';
</style>
